import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f54ff160"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onMouseenter", "onMouseleave"];
const _hoisted_2 = {
  class: "produtes-content"
};
const _hoisted_3 = {
  class: "produtes-title"
};
const _hoisted_4 = {
  class: "produtes-description"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0,
  class: "goods"
};
const _hoisted_7 = {
  class: "fadeInUp",
  wait: "500"
};
const _hoisted_8 = {
  class: "con-box"
};
const _hoisted_9 = {
  class: "goods-cards fadeInUp",
  wait: "500"
};
const _hoisted_10 = {
  class: "goods-img"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "goods-title"
};
const _hoisted_13 = {
  class: "box-lr fadeInUp"
};
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = ["data", "alt"];
const _hoisted_16 = {
  class: "right con-box-container"
};
const _hoisted_17 = {
  class: "txt"
};
const _hoisted_18 = {
  class: "goods"
};
const _hoisted_19 = {
  class: "con-box"
};
const _hoisted_20 = {
  class: "goods-cards"
};
const _hoisted_21 = {
  class: "goods-img"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "goods-title"
};
const _hoisted_24 = {
  class: "box-lr"
};
const _hoisted_25 = {
  class: "left"
};
const _hoisted_26 = ["data", "alt"];
const _hoisted_27 = {
  class: "right con-box-container"
};
const _hoisted_28 = {
  class: "txt"
};
import { ref, onMounted, watch } from 'vue';
import { isMobile, tabHoverIndex, observe } from '@/utils';
// 资源
import eContractbc from '@/assets/img/e-contract-bc.svg';
export default {
  __name: 'goods',
  setup(__props) {
    const tab1 = ref('contract');
    const eContractStyle = () => {
      return {
        height: '380px',
        background: `url(${eContractbc}) no-repeat`
      };
    };
    const goodList = ref([{
      key: 'contract',
      navMobil: '电子合同',
      navName: '智识签',
      navDesc: '在线签约、技术专利 、高效安全',
      navClass: 'e-contract',
      mouseClass: ref(''),
      cards: [{
        label: '高效便捷',
        img: require('./img/card1_1.png')
      }, {
        label: '智能审批',
        img: require('./img/card1_2.png')
      }, {
        label: '注册即用',
        img: require('./img/card1_3.png')
      }, {
        label: '安全可靠',
        img: require('./img/card1_4.png')
      }],
      title: '亲笔签电子合同',
      layoutImg: require('./img/goods1.svg'),
      layoutStyle: eContractStyle(),
      layoutTitle: '数字笔迹电子签署平台',
      contentText: '基于数字笔迹AI识别技术，将签名和印章无缝衔接，实现全国互通互认互验，不受时空约束，随时随地可在线签署、管理的电子合同签署平台，注册即用。'
    }, {
      key: 'sign',
      navMobil: '电子签章',
      navName: '电子印章',
      navDesc: '远程签章、签名调章',
      mouseClass: ref(''),
      navClass: 'e-sign',
      cards: [{
        label: '签名调章',
        img: require('./img/card2_1.png')
      }, {
        label: '用印留痕',
        img: require('./img/card2_2.png')
      }, {
        label: '授权管理',
        img: require('./img/card2_3.png')
      }, {
        label: '互通互验',
        img: require('./img/card2_4.png')
      }],
      title: '亲笔签电子印章',
      layoutImg: require('./img/goods2.svg'),
      layoutStyle: eContractStyle(),
      layoutTitle: '数字笔迹电子签署平台',
      contentText: '基于数字笔迹AI识别技术，结合实际应用需求，通过建设全市统一电子化签名印章及存证服务，推行政企服务生命全周期数字化。构建业务流、数据流、证据流“三流合一”的证据链闭环，形成可跨系统、跨机构、跨平台流通及互验互认的证据数据系统，助力数字化转型。'
    }, {
      key: 'file',
      navMobil: '智册管',
      navName: '智册管',
      navDesc: '电子存档、证据闭环、安全性强',
      mouseClass: ref(''),
      navClass: 'e-file',
      cards: [{
        label: '统一存证',
        img: require('./img/card3_1.png')
      }, {
        label: '统一验证',
        img: require('./img/card3_2.png')
      }, {
        label: '统一管理',
        img: require('./img/card3_3.png')
      }, {
        label: '全周期存储',
        img: require('./img/card3_4.png')
      }],
      title: '亲笔签电子档案',
      layoutImg: require('./img/goods3.svg'),
      layoutStyle: eContractStyle(),
      layoutTitle: '数字笔迹电子签署平台',
      contentText: '基于区块链技术建设电子档案存证中心，运用电子签名、电子签章等技术，对档案文件归档及电子档案管理、利用、鉴定销毁的全生命周期进行存证。通过以电子签名、签章为节点形成档案全周期证据链闭环，满足OA电子公文签发及业务事项办理的“办结即归档”，从而真正实现全流程电子档案管理。'
    }, {
      key: 'type',
      navMobil: '笔迹+',
      navName: '笔迹+',
      navDesc: '身份识别、安全登录、全场景适用',
      mouseClass: ref(''),
      navClass: 'e-type',
      cards: [{
        label: '笔迹加密',
        img: require('./img/card4_1.png')
      }, {
        label: '笔迹登录',
        img: require('./img/card4_2.png')
      }, {
        label: '笔迹通行',
        img: require('./img/card4_3.png')
      }, {
        label: '笔迹支付',
        img: require('./img/card4_4.png')
      }],
      title: '亲笔签数字笔迹识别',
      layoutImg: require('./img/goods4.svg'),
      layoutStyle: eContractStyle(),
      layoutTitle: '数字笔迹电子签署平台',
      contentText: '用数字笔迹手写电子签名特有的身份+意愿双重确认能力打造的，基于身份和数字安全的基座，通过应用层上的创新，在密码、通行证、数字身份、支付等领域推出的安全创新应用产品，致力于为整个数字经济体贡献超前基础联通转流能力。'
    }]);
    const tabs = ref(null);
    const mouseEnter = item => {
      item.mouseClass = 'is-enter';
    };
    const mouseLeave = item => {
      item.mouseClass = 'is-leave';
    };

    // const _cls = ref([]);

    // const combinClass = (item) => {

    //   return ref([item.navClass, item.mouseClass.value]).value;
    // };

    onMounted(() => {
      if (!isMobile() && tabs.value) {
        tabHoverIndex(tabs.value, index => {
          var _goodList$value$index;
          const key = (_goodList$value$index = goodList.value[index]) === null || _goodList$value$index === void 0 ? void 0 : _goodList$value$index.key;
          if (key && tab1.value !== key) {
            tab1.value = key;
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_var_tab_item = _resolveComponent("var-tab-item");
      const _component_var_tabs_items = _resolveComponent("var-tabs-items");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_a_tabs, {
        class: _normalizeClass(_unref(isMobile)() ? 'produtes-mobile' : 'produtes'),
        activeKey: tab1.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tab1.value = $event),
        ref_key: "tabs",
        ref: tabs,
        "force-render": true,
        centered: "",
        tabBarGutter: _unref(isMobile)() ? 40 : 18
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodList.value, item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.key,
            forceRender: true
          }, {
            tab: _withCtx(() => [!_unref(isMobile)() ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "produtes-item",
              onMouseenter: () => mouseEnter(item),
              onMouseleave: () => mouseLeave(item)
            }, [_createElementVNode("div", {
              class: _normalizeClass(["produtes-img", [item.navClass, item.mouseClass]])
            }, null, 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.navName), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.navDesc), 1)])], 40, _hoisted_1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.navMobil), 1))]),
            default: _withCtx(() => [!_unref(isMobile)() ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("h3", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cards, (card, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "goods-item",
                key: index
              }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
                src: card.img
              }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, _toDisplayString(card.label), 1)]);
            }), 128))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("object", {
              type: "image/svg+xml",
              data: item.layoutImg,
              alt: item.layoutTitle
            }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(item.contentText), 1)])])])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["class", "activeKey", "tabBarGutter"]), _unref(isMobile)() ? (_openBlock(), _createBlock(_component_var_tabs_items, {
        key: 0,
        active: tab1.value,
        "onUpdate:active": _cache[1] || (_cache[1] = $event => tab1.value = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodList.value, item => {
          return _openBlock(), _createBlock(_component_var_tab_item, {
            key: item.key,
            name: item.key
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cards, (card, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "goods-item",
                key: index
              }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
                src: card.img
              }, null, 8, _hoisted_22)]), _createElementVNode("div", _hoisted_23, _toDisplayString(card.label), 1)]);
            }), 128))]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("object", {
              type: "image/svg+xml",
              data: item.layoutImg,
              alt: item.layoutTitle
            }, null, 8, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", _hoisted_28, _toDisplayString(item.contentText), 1)])])])])]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"])) : _createCommentVNode("", true)], 64);
    };
  }
};